import React from 'react';

import CampaignDeals from '../../../../components/campaign-deals';
import ErrorBoundary from '../../../../components/error-boundary';

import Lazy from '../../../../components/lazy';

import { Product } from '../../../../types';

const ProductCampaignDeals: React.FC<IProductCampaignDealsProps> = props => {
  const { product } = props;
  return product.category &&
    product.category.deals &&
    product?.category?.deals.length > 0 ? (
    <ErrorBoundary onError={returnNull}>
      <Lazy offset={100}>
        <CampaignDeals
          deals={product.category.deals}
          campaignLinkQuery={`?category=${product.category.id}`}
        />
      </Lazy>
    </ErrorBoundary>
  ) : null;
};

interface IProductCampaignDealsProps {
  product: Product;
}

const returnNull = () => null;
export default ProductCampaignDeals;
